/*------ for animations ------*/
$(document).ready(function () {
  // Select the h1 element by its tag name
  var heading = $('.main-banner-content h1');

  // Add a class to the h1 element
  heading.addClass('highlight');

  const elementsToAnimate = $('p, h1, h2, h3, h4, h5, h6, #main img');
  const observerOptions = { threshold: 0.5 };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        activateAnimation($(entry.target));
      }
    });
  }, observerOptions);

  elementsToAnimate.each(function () {
    observer.observe($(this)[0]);
  });

  function activateAnimation(element) {
    if (element.prop('tagName').toLowerCase() === 'img') {
      element.addClass("scale-animation");
    } else {
      element.addClass("animate");
    }
    observer.unobserve(element[0]);
  }
});



// function handleMediaQueryChange(event) {
//   if (event.matches) {
//     // Screen size is 768 pixels or smaller, run the code
//     const listItems = document.querySelectorAll('.main-menu > li');

//     listItems.forEach(item => {
//       item.addEventListener('click', function() {
//         // Toggle the class 'number' when the li is clicked
//         this.classList.toggle('number');
//       });
//     });
//   } else {
//     // Screen size is greater than 768 pixels, optionally remove event listeners or do nothing
//     const listItems = document.querySelectorAll('.main-menu > li');

//     listItems.forEach(item => {
//       item.classList.remove('number');
//     });
//   }
// }

// // Create a MediaQueryList object
// const mediaQuery = window.matchMedia("(max-width: 768px)");

// // Check the screen size on page load
// handleMediaQueryChange(mediaQuery);

// // Listen for changes in the screen size
// mediaQuery.addEventListener('change', handleMediaQueryChange);



// $(document).ready(function() {
//     $('ul.main-menu>li').click(function() {
//         if ($(window).width() < 769) {  // Check if the screen width is smaller than 769px
//             $('.sub-menu-main-holder').slideToggle(); // Toggle slide up and down
//         }
//     });
// });

$(document).ready(function() {
    $('ul.main-menu > li').click(function() {
        if ($(window).width() < 769) {  // Check if the screen width is smaller than 769px
            $(this).children('.sub-menu-main-holder').slideToggle(); // Toggle the corresponding .sub-menu-main-holder within the clicked li
        }
    });
});


$(document).ready(function() {
    $('.hamburger').click(function() {
        $('.main-cart-area').toggleClass('change-cart-color'); // Toggles 'active' class on click
    });
});




$(document).ready(function() {
    $('.hamburger').click(function() {
        $('.announcment-main-holder').toggleClass('hide-announcment-bar'); // Toggles 'hide-announcment-bar' class on click
    });
});


$(document).ready(function() {
    $('.hamburger').click(function() {
        $('html').toggleClass('hidden-height'); // Toggle the 'menu-open' class on <html>
    });
});


$(document).ready(function() {
    $('.faq-question').click(function() {
        $(this).find('img').toggleClass('rotate-img'); // Toggle the class only on the clicked element
    });
});




  document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('ul.policy-link-list li a, ul.information-link-list li a');
    
    // Apply the stored class if a link was previously clicked
    const activeLink = localStorage.getItem('activeLink');
    if (activeLink) {
      document.querySelectorAll('ul.policy-link-list li a, ul.information-link-list li a').forEach(function(anchor) {
        if (anchor.href === activeLink) {
          anchor.classList.add('your-class-name');
        }
      });
    }

    anchors.forEach(function(anchor) {
      anchor.addEventListener('click', function() {
        // Remove the class from all anchors
        anchors.forEach(function(anchor) {
          anchor.classList.remove('your-class-name');
        });

        // Add the class to the clicked anchor
        this.classList.add('your-class-name');

        // Store the clicked link's URL
        localStorage.setItem('activeLink', this.href);
      });
    });
  });









window.addEventListener('scroll', function() {
    var header = document.getElementById('header');
    
    if (window.scrollY > 10) { // Change '50' to the number of pixels after which you want to add the class
        header.classList.add('header-scrolled');
    } else {
        header.classList.remove('header-scrolled');
    }
});

document.querySelector('.hamburger').addEventListener('click', function() {
    this.classList.toggle('hamburger-menu'); // Toggles the class on the hamburger menu
    document.querySelector('#nav').classList.toggle('show-nav-menu'); // Toggles the class on the navbar
});



// // // Get all menu list items (li) in the main menu
// const menuItems = document.querySelectorAll('.main-menu > li');

// menuItems.forEach(item => {
//     const menuLinks = item.querySelectorAll('.sub-menu a');
//     const productItems = item.querySelectorAll('.women-products > div');
//     const menuHolder = item.querySelector('.sub-menu-main-holder');

//     // Function to deactivate all product items within the current menu item
//     function deactivateItems() {
//         productItems.forEach(productItem => productItem.classList.remove('active'));
//     }

//     // Function to activate the first product item within the current menu item
//     function activateFirstItem() {
//         const firstItem = productItems[0];
//         if (firstItem) {
//             firstItem.classList.add('active');
//         }
//     }

//     // Add hover event listener to each menu link within the current menu item
//     menuLinks.forEach(link => {
//         link.addEventListener('mouseover', function(event) {
//             event.preventDefault(); // Prevent default link behavior

//             // Deactivate all items within this menu item
//             deactivateItems();

//             // Get the ID of the item to be activated
//             const targetId = link.getAttribute('data-id');

//             // Find the corresponding product item within this menu item and activate it
//             const targetItem = item.querySelector(targetId);
//             if (targetItem) {
//                 targetItem.classList.add('active');
//             }
//         });
//     });

//     // Add mouseleave event listener to the menu holder within the current menu item
//     menuHolder.addEventListener('mouseleave', function() {
//         // Deactivate all items within this menu item
//         deactivateItems();

//         // Activate the first product item within this menu item
//         activateFirstItem();
//     });

//     // Activate the first product item by default within this menu item
//     activateFirstItem();
// });


// Function to execute the code based on screen width
function initializeMenu() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 769) {
        // Get all menu list items (li) in the main menu
        const menuItems = document.querySelectorAll('.main-menu > li');

        menuItems.forEach(item => {
            const menuLinks = item.querySelectorAll('.sub-menu a');
            const productItems = item.querySelectorAll('.women-products > div');
            const menuHolder = item.querySelector('.sub-menu-main-holder');

            // Function to deactivate all product items within the current menu item
            function deactivateItems() {
                productItems.forEach(productItem => productItem.classList.remove('active'));
            }

            // Function to activate the first product item within the current menu item
            function activateFirstItem() {
                const firstItem = productItems[0];
                if (firstItem) {
                    firstItem.classList.add('active');
                }
            }

            // Add hover event listener to each menu link within the current menu item
            menuLinks.forEach(link => {
                link.addEventListener('mouseover', function(event) {
                    event.preventDefault(); // Prevent default link behavior

                    // Deactivate all items within this menu item
                    deactivateItems();

                    // Get the ID of the item to be activated
                    const targetId = link.getAttribute('data-id');

                    // Find the corresponding product item within this menu item and activate it
                    const targetItem = item.querySelector(targetId);
                    if (targetItem) {
                        targetItem.classList.add('active');
                    }
                });
            });

            // Add mouseleave event listener to the menu holder within the current menu item
            menuHolder.addEventListener('mouseleave', function() {
                // Deactivate all items within this menu item
                deactivateItems();

                // Activate the first product item within this menu item
                activateFirstItem();
            });

            // Activate the first product item by default within this menu item
            activateFirstItem();
        });
    }
}

// Run the function on page load
initializeMenu();

// Run the function on window resize
window.addEventListener('resize', initializeMenu);




// =============video-popup-code==============
let playButtons = document.querySelectorAll('.video-sec .play-btn');
let videoPopup = document.querySelector('.popup-video');
let videoClose = document.querySelector('.popup-video span');

playButtons.forEach(playbtn => {
    playbtn.addEventListener('click', function(e){
        e.preventDefault();
        videoPopup.style.display = 'block';
        let videoSrc = playbtn.getAttribute('data-video-src');
        let popupVideo = videoPopup.querySelector('video');
        popupVideo.src = videoSrc;
        document.body.classList.add('video-popup');
    });
});
videoClose.addEventListener('click', function(){
    document.body.classList.remove('video-popup');
});




// =============faq-code============
function toggleAnswer(element) {
    const answer = element.nextElementSibling;
    answer.classList.toggle('open');
}




// ===============window scroll add class===========
jQuery(function($){
		var $navbar = $('.elementor-location-header');
		$(window).scroll(function(event){
			var $current = $(this).scrollTop();
			if( $current > 0 ){
				$navbar.addClass('navbar-color');
				
			} else{
				$navbar.removeClass('navbar-color');
			}
		})
		
	});





